import { CircularProgress, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import _ from 'lodash';
import React from 'react';

/**
 * @typedef {Object} AutocompleteSearchOnLoading
 * @property {boolean} enabledSearch
 * @property {string} searchString
 */
/**
 * 
 * @param {import('@material-ui/lab').AutocompleteProps<Structure> & {
 *  enabledSearch?: boolean
 *  onLoading: ( event: AutocompleteSearchOnLoading ) => null,
 *  inputLabel?: string
 * }} param0 
 * @returns 
 */
const AutocompleteSearch = ({ onLoading, inputLabel = '', enabledSearch = false, ...props }) => {
    //
    const [ open, setOpen ] = React.useState(false)
    const [ searchString, setSearchString ] = React.useState('')

    //
    if ( !_.isFunction(onLoading) ) {
        throw Error("onLoading is required to be a function")
    }

    // Informa ao componenete que precisa buscar condeudo na api
    const loading = open &&
        // Se o load por pesquisa estiver desativado retorna true
        ( ! enabledSearch || searchString.length >= 3 ) &&
        // Se o load por pesquisa estiver ativado retorna true
        ( _.isEmpty(props.options) || enabledSearch )

    //
    React.useEffect(() => {
        
        if ( !loading ) {
            return;
        }

        onLoading({ enabledSearch, searchString })

    }, [enabledSearch, loading, onLoading, searchString])

    return (
        <Autocomplete
            className="w-100"
            getOptionSelected={(option, value) => option.id === value.id}
            getOptionLabel={(option) => option.name }
            {...props}
            renderInput={(params) => (
                <TextField
                {...params}
                label={inputLabel}
                variant="standard"
                InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                    <React.Fragment>
                        {loading ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                    </React.Fragment>
                    ),
                }}
                />
            )}
            open={open}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            onInput={({ target }) => {
                setSearchString(target.value)
            }}
            />
    )
}

export default AutocompleteSearch